const resetListeners = new Set<(clearPendingOperations: boolean) => void>();
let generation = 0;
let controller = new AbortController();
export const getSessionGeneration = () => generation;
export const getSessionSignal = () => controller.signal;
export function onSessionReset(listener: (clearPendingOperations: boolean) => void) {
  resetListeners.add(listener);
  return () => { resetListeners.delete(listener); };
}
export function resetSessionRuntime(clearPendingOperations: boolean) {
  generation += 1;
  const previous = controller;
  controller = new AbortController();
  previous.abort();
  for (const listener of resetListeners) {
    try { listener(clearPendingOperations); } catch { /* A widget cannot prevent Redux from clearing the session. */ }
  }
}
export function registerSessionQueryClient(client: {cancelQueries: () => Promise<unknown>; clear: () => void}) {
  return onSessionReset(() => {
    void client.cancelQueries().catch(() => undefined);
    client.clear();
  });
}
